var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _mask, _path27, _path28, _path29, _mask2, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEmptyCerts = function SvgEmptyCerts(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 466,
    height: 340,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50.001%",
    x2: "100%",
    y2: "50.001%",
    id: "emptyCerts_svg__a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFD5F1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E5F6",
    offset: "28.3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F8FD",
    offset: "71.9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "emptyCerts_svg__b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFD5F1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E5F6",
    offset: "28.3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F8FD",
    offset: "71.9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "emptyCerts_svg__c"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D7F3",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "emptyCerts_svg__d"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D7F3",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.552%",
    y1: "59.019%",
    x2: "107.241%",
    y2: "-25.345%",
    id: "emptyCerts_svg__e"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB384",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF826A",
    offset: "56.4%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF826A",
    offset: "78.4%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF6537",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.681%",
    y1: "60.013%",
    x2: "90.837%",
    y2: "-33.644%",
    id: "emptyCerts_svg__f"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB384",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF826A",
    offset: "56.4%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF826A",
    offset: "78.4%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF6537",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.552%",
    y1: "57.372%",
    x2: "107.241%",
    y2: "-11.585%",
    id: "emptyCerts_svg__g"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB384",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF826A",
    offset: "56.4%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF826A",
    offset: "78.4%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF6537",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "45.436%",
    y1: "80.992%",
    x2: "63.747%",
    y2: "12.203%",
    id: "emptyCerts_svg__h"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5284C",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C13053",
    offset: "16%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "45.435%",
    y1: "80.992%",
    x2: "63.748%",
    y2: "12.203%",
    id: "emptyCerts_svg__i"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5284C",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C13053",
    offset: "16%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "emptyCerts_svg__j"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D7F3",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "emptyCerts_svg__k"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D7F3",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "56.366%",
    y1: "58.174%",
    x2: "94.898%",
    y2: "-10.048%",
    id: "emptyCerts_svg__l"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54AFAE",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A7776",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "8.585%",
    x2: "50%",
    y2: "125.022%",
    id: "emptyCerts_svg__m"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54AFAE",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A7776",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "46.238%",
    y1: "113.478%",
    x2: "50%",
    y2: "18.254%",
    id: "emptyCerts_svg__n"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20196F",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4BA3A2",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "36.213%",
    x2: "35.32%",
    y2: "50%",
    id: "emptyCerts_svg__o"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54AFAE",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4DA6A5",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "emptyCerts_svg__p"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D7F3",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "emptyCerts_svg__q"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE0F5",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1F5",
    offset: ".6%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF1FB",
    offset: "22.8%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFCFE",
    offset: "44.9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "66.9%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "emptyCerts_svg__t"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8ECF7",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "emptyCerts_svg__u"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8ECF7",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "emptyCerts_svg__v"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE0F5",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1F5",
    offset: ".6%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF1FB",
    offset: "22.8%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFCFE",
    offset: "44.9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "66.9%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "emptyCerts_svg__y"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8ECF7",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "49.998%",
    x2: "100%",
    y2: "49.998%",
    id: "emptyCerts_svg__z"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFD5F1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E5F6",
    offset: "28.3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F8FD",
    offset: "71.9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50.002%",
    x2: "100%",
    y2: "50.002%",
    id: "emptyCerts_svg__A"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFD5F1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E5F6",
    offset: "28.3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F8FD",
    offset: "71.9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-.001%",
    y1: "49.999%",
    x2: "99.999%",
    y2: "49.999%",
    id: "emptyCerts_svg__B"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4C9E4",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "49.999%",
    x2: "99.998%",
    y2: "49.999%",
    id: "emptyCerts_svg__C"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC16B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBF6B",
    offset: "1.2%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F38764",
    offset: "34.7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA5E60",
    offset: "63.6%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5455D",
    offset: "86.2%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E33C5C",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "emptyCerts_svg__D"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8DEF0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CCE7",
    offset: "55.1%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDC3E3",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50.001%",
    x2: "100%",
    y2: "50.001%",
    id: "emptyCerts_svg__E"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFD5F1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E5F6",
    offset: "28.3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F8FD",
    offset: "71.9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: ".001%",
    y1: "49.999%",
    x2: "100%",
    y2: "49.999%",
    id: "emptyCerts_svg__F"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFD5F1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D5F1",
    offset: ".7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAECF9",
    offset: "38.9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9FAFD",
    offset: "73.2%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "49.999%",
    x2: "100%",
    y2: "49.999%",
    id: "emptyCerts_svg__G"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4C9E4",
    offset: "42.7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7DAED",
    offset: "57.7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F5FA",
    offset: "84.6%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "49.999%",
    x2: "99.998%",
    y2: "49.999%",
    id: "emptyCerts_svg__H"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC16B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBF6B",
    offset: "1.2%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F38764",
    offset: "34.7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA5E60",
    offset: "63.6%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5455D",
    offset: "86.2%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E33C5C",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "49.999%",
    x2: "100.001%",
    y2: "49.999%",
    id: "emptyCerts_svg__I"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4C9E4",
    offset: "42.7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7DAED",
    offset: "57.7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F5FA",
    offset: "84.6%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "49.999%",
    x2: "99.998%",
    y2: "49.999%",
    id: "emptyCerts_svg__J"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC16B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBF6B",
    offset: "1.2%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F38764",
    offset: "34.7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA5E60",
    offset: "63.6%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5455D",
    offset: "86.2%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E33C5C",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-.037%",
    y1: "50.001%",
    x2: "100%",
    y2: "50.001%",
    id: "emptyCerts_svg__K"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D7F3",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFE3F7",
    offset: "37.9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "48.174%",
    y1: "0%",
    x2: "53.958%",
    y2: "109.395%",
    id: "emptyCerts_svg__L"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F63",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE5020",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "89.033%",
    y1: "125.802%",
    x2: "5.293%",
    y2: "-32.708%",
    id: "emptyCerts_svg__M"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBC0E6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEC3E8",
    offset: "11.8%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CED3F8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1150.846%",
    y1: "775.834%",
    x2: "1263.9%",
    y2: "775.834%",
    id: "emptyCerts_svg__N"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#423EAF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#423EAF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "46.302%",
    y1: "0%",
    x2: "58.016%",
    y2: "109.395%",
    id: "emptyCerts_svg__O"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F63",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE5020",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "53.317%",
    y1: "59.781%",
    x2: "91.393%",
    y2: "37.492%",
    id: "emptyCerts_svg__P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F63",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE5020",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "50%",
    x2: "0%",
    y2: "50%",
    id: "emptyCerts_svg__Q"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBC0E6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E7F5",
    offset: "66.2%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F6FB",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-.001%",
    y1: "50.011%",
    x2: "100%",
    y2: "50.011%",
    id: "emptyCerts_svg__R"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5652CC",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#443EAD",
    offset: "50.9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#362E94",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50.001%",
    x2: "100%",
    y2: "50.001%",
    id: "emptyCerts_svg__S"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#383564",
    offset: "50.9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#252240",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "43.638%",
    y1: "32.273%",
    x2: "63.79%",
    y2: "71.058%",
    id: "emptyCerts_svg__T"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F63",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE5020",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "158.674%",
    y1: "24.309%",
    x2: "-44.848%",
    y2: "70.227%",
    id: "emptyCerts_svg__U"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBC0E6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E7F5",
    offset: "66.2%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F6FB",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: ".001%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "emptyCerts_svg__V"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D7F3",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDE2F6",
    offset: "34.7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFEFF",
    offset: "97.9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "49.999%",
    x2: "99.998%",
    y2: "49.999%",
    id: "emptyCerts_svg__W"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC16B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBF6B",
    offset: "1.2%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F38764",
    offset: "34.7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA5E60",
    offset: "63.6%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5455D",
    offset: "86.2%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E33C5C",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "emptyCerts_svg__X"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7FFBF9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6FECEB",
    offset: "21.3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50BAB9",
    offset: "70.2%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#358685",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-.001%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "emptyCerts_svg__Z"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD03E",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDCC3A",
    offset: "23.5%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7BF2F",
    offset: "48%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECAB1C",
    offset: "73%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD8E02",
    offset: "98.1%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC8B00",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "94.898%",
    y1: "53.904%",
    x2: "4.425%",
    y2: "46.802%",
    id: "emptyCerts_svg__aa"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC8B00",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2B526",
    offset: "63.5%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD03E",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m0 51.675 87.567 50.662c.596-1.57.915-3.231.944-4.91V68.826c0-4.761 2.56-10.303 6.177-14.043L0 0v51.675Zm126.313 36.988v28.6a18.121 18.121 0 0 1-1.425 6.666l26.055 15.074a14.6 14.6 0 0 0 .974-4.999v-28.6c0-4.733 2.529-10.238 6.11-13.977l-25.944-15.01c-3.335 3.065-5.77 8.027-5.77 12.246Zm69.103 24.396c-3.298 3.07-5.696 7.993-5.696 12.18v28.601a18.179 18.179 0 0 1-1.461 6.752l60.972 35.276v-51.674l-53.815-31.135Z",
    id: "emptyCerts_svg__r"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.3 76.832c-3.942 2.883-6.987 8.526-6.987 13.242v28.601c0 .471-.032.95-.081 1.434l131.242 75.646v-47.352L133.301 76.832ZM0 47.352l88.512 51.016v-28.13c0-5.213 3.069-11.358 7.233-15.053L0 0v47.352Z",
    id: "emptyCerts_svg__w"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "23.499%",
    cy: "30.853%",
    fx: "23.499%",
    fy: "30.853%",
    r: "81.464%",
    gradientTransform: "matrix(.99935 0 0 1 0 0)",
    id: "emptyCerts_svg__Y"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78E3E2",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A7776",
    offset: "100%"
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#emptyCerts_svg__a)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M259.9 37.743h-38.04l23.78 14.144-23.78 13.724h38.04l24.142-13.93L259.9 37.743z",
    transform: "translate(0 29.596)"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B9BEE4",
    fillRule: "nonzero",
    d: "m221.86 95.207 23.78-13.724V43.311l-23.78 13.72z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#CCD1F6",
    fillRule: "nonzero",
    d: "m221.86 95.207-23.783-13.724V43.311l23.782 13.72z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4F4F9",
    fillRule: "nonzero",
    d: "m221.86 57.031-23.783-13.72 23.782-13.715 23.78 13.715z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#emptyCerts_svg__b)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M127.723 281.881H109.82l11.194 6.658-11.194 6.458h17.904l11.364-6.556-11.364-6.56z",
    transform: "translate(0 29.596)"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#B9BEE4",
    fillRule: "nonzero",
    d: "m109.819 324.593 11.194-6.458V305.02l-11.194 6.456v13.116z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#CCD1F6",
    fillRule: "nonzero",
    d: "m109.819 324.593-11.196-6.458V305.02l11.196 6.456v13.116z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4F4F9",
    fillRule: "nonzero",
    d: "m109.819 311.477-11.196-6.456 11.196-6.457 11.194 6.457-11.194 6.456z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#DFE4F4",
    fillRule: "nonzero",
    d: "m114.087 305.02-4.268-2.461-4.27 2.462 4.27 2.461z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m216.243 195.59 8.901-5.136h-3.422l-8.901 5.136c-3.045 1.756-17.45-1.796-25.898 3.078-6.53 3.768-7.42 16.145-9.774 17.503l-64.197 37.04h3.422l64.198-37.04c4.452-2.57 15.28-4.652 24.186-4.652h29.205v-11.278h-9.659c-8.905 0-12.514-2.082-8.062-4.651Z",
    fill: "url(#emptyCerts_svg__c)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    transform: "translate(0 29.596)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m323.14 133.913 8.9-5.136h-3.421l-8.901 5.136c-3.045 1.756-17.451-1.796-25.898 3.078-6.53 3.768-7.42 16.145-9.773 17.503l-80.64 46.527h3.423l80.639-46.527c4.452-2.569 15.28-4.652 24.186-4.652h29.205v-11.278h-9.658c-8.905 0-12.515-2.082-8.063-4.651Z",
    fill: "url(#emptyCerts_svg__d)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    transform: "translate(0 29.596)"
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M319.717 161.534c-4.452 2.57-8.062.487-8.062-4.652v-28.6c0-6.229-4.376-8.754-9.773-5.64-5.398 3.115-9.773 10.689-9.773 16.917v28.602c0 5.137-3.61 11.385-8.062 13.954l-71.226 41.096c-4.453 2.57-8.063.487-8.063-4.651v-28.601c0-6.229-4.376-8.753-9.773-5.64-5.398 3.115-9.773 10.689-9.773 16.918v28.6c0 5.139-3.61 11.387-8.063 13.956l-64.197 37.04v1.975l64.197-37.04c5.398-3.115 9.774-10.689 9.774-16.918v-28.6c0-5.139 3.61-11.387 8.062-13.956 4.453-2.569 8.062-.486 8.062 4.652v28.601c0 6.228 4.376 8.753 9.774 5.639l71.226-41.096c5.397-3.115 9.773-10.688 9.773-16.917v-28.6c0-5.139 3.61-11.387 8.062-13.956 4.453-2.57 8.062-.486 8.062 4.652v28.6c0 6.23 4.376 8.754 9.773 5.64l51.699-29.829v-1.974l-51.699 29.828Z",
    fill: "#E33C5C",
    fillRule: "nonzero"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m335.324 112.856-7.103-4.098v-1.975l7.103 4.099v1.974ZM112.952 282.808l-36.091-20.824v-1.975l36.091 20.824v1.975Z",
    fill: "#FF826A",
    fillRule: "nonzero"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M165.968 133.32c-1.78-1.13-4.29-1.027-7.074.58-5.398 3.114-9.774 10.688-9.774 16.917v28.6c0 5.139-3.61 11.387-8.062 13.956l-64.197 37.04 36.091 20.824 64.198-37.04c4.452-2.57 8.062-8.817 8.062-13.956v-28.6c0-6.229 4.376-13.803 9.773-16.917 2.699-1.557 5.142-1.705 6.91-.684l-35.927-20.72Z",
    fill: "url(#emptyCerts_svg__e)",
    fillRule: "nonzero",
    transform: "translate(0 29.596)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M204.758 160.363v28.6c0 5.138 3.61 7.221 8.062 4.653l71.227-41.096c.278-.161.552-.336.823-.524 4.066-2.822 7.239-8.615 7.239-13.431v-28.602c0-.389.016-.783.05-1.182a16.48 16.48 0 0 1 .257-1.814 20.191 20.191 0 0 1 .656-2.45c.138-.407.288-.813.452-1.218a23.816 23.816 0 0 1 3.29-5.696 19.544 19.544 0 0 1 3.58-3.568 14.235 14.235 0 0 1 1.488-.988 9.372 9.372 0 0 1 3.804-1.31l.088-.004a6.46 6.46 0 0 1 .345-.02c.032 0 .064.003.096.002.11 0 .218 0 .326.005.033.002.066.007.1.009.237.014.472.045.705.09.046.01.092.024.137.034.083.02.166.037.246.06.038.01.073.025.11.037.088.027.175.053.26.085l.062.027c.218.084.429.184.631.3l-35.927-20.72c-1.78-1.129-4.29-1.026-7.074.58-5.398 3.115-9.773 10.689-9.773 16.918v28.6c0 5.139-3.61 11.386-8.063 13.956l-43.75 25.242c.385 1.1.572 2.26.553 3.424Z",
    fill: "url(#emptyCerts_svg__f)",
    fillRule: "nonzero",
    transform: "translate(0 29.596)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M335.324 81.286 311.103 95.26c.385 1.1.572 2.259.553 3.424v28.6c0 5.138 3.61 7.221 8.061 4.653l51.699-29.828-36.092-20.824Z",
    fill: "url(#emptyCerts_svg__g)",
    fillRule: "nonzero",
    transform: "translate(0 29.596)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M186.923 170.653v14.644l18.64 10.754c-1.563-1.097-2.516-3.195-2.516-6.1V161.35c0-5.138-3.61-7.22-8.062-4.652-4.452 2.569-8.062 8.817-8.062 13.955Z",
    fill: "url(#emptyCerts_svg__h)",
    fillRule: "nonzero",
    transform: "translate(0 29.596)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M293.82 108.976v14.644l18.64 10.754c-1.564-1.097-2.516-3.195-2.516-6.1V99.673c0-5.138-3.61-7.221-8.062-4.652-4.453 2.57-8.062 8.817-8.062 13.955Z",
    fill: "url(#emptyCerts_svg__i)",
    fillRule: "nonzero",
    transform: "translate(0 29.596)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#FE9072",
    fillRule: "nonzero",
    d: "m391.65 99.207-63.43 7.576 50.298 29.021z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF826A",
    fillRule: "nonzero",
    d: "m378.518 137.779-7.102-4.099v-1.974l7.102 4.098z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#E33C5C",
    fillRule: "nonzero",
    d: "m391.65 101.181-13.132 36.598v-1.975l13.132-36.597z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#DAE0F5",
    fillRule: "nonzero",
    d: "m342.455 152.454 30.749-17.742-1.788-1.032-30.75 17.742z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E8ECF7",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    d: "m373.204 105.116-1.788-3.006v1.974z",
    transform: "translate(0 29.596)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#emptyCerts_svg__j)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    d: "m391.65 71.585-13.132 36.598h3.423l13.131-36.598z",
    transform: "translate(0 29.596)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m279.649 232.167 8.902-5.136h-3.423l-8.901 5.136c-3.044 1.756-17.45-1.796-25.898 3.078-6.53 3.768-7.42 16.145-9.773 17.503l-64.204 37.044h3.423l64.203-37.044c4.453-2.569 15.281-4.652 24.187-4.652h29.204V236.82h-9.658c-8.905 0-12.515-2.083-8.062-4.652Z",
    fill: "url(#emptyCerts_svg__k)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    transform: "translate(0 29.596)"
  }), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M276.227 259.788c-4.453 2.57-8.062.487-8.062-4.652v-28.6c0-6.229-4.376-8.754-9.774-5.64-5.397 3.115-9.773 10.689-9.773 16.917v28.602c0 5.137-3.61 11.385-8.062 13.954l-64.204 37.044v1.975l64.204-37.044c5.397-3.115 9.773-10.688 9.773-16.917v-28.6c0-5.139 3.61-11.387 8.062-13.956 4.453-2.569 8.063-.486 8.063 4.652v28.6c0 6.23 4.375 8.754 9.773 5.64l44.49-25.67v-1.975l-44.49 25.67ZM284.626 215.269l-7.103-4.099v-1.974l7.103 4.098z",
    fill: "#388A89",
    fillRule: "nonzero"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M229.375 169.896c-1.78-1.129-4.29-1.026-7.075.58-5.398 3.115-9.773 10.689-9.773 16.918v28.6c0 5.139-3.61 11.386-8.063 13.956l-58.39 33.69-5.813 3.354 36.091 20.823 64.204-37.044c.278-.16.553-.335.824-.523 4.066-2.822 7.238-8.615 7.238-13.431v-28.602c0-.389.017-.783.05-1.182.052-.609.138-1.214.258-1.814.08-.406.175-.814.285-1.224.11-.408.233-.817.37-1.225.138-.408.289-.814.452-1.219a23.816 23.816 0 0 1 3.29-5.696 19.547 19.547 0 0 1 3.58-3.568 14.235 14.235 0 0 1 1.488-.988 9.372 9.372 0 0 1 3.805-1.31l.087-.004c.116-.009.232-.016.346-.019.032 0 .063.002.095.001.11 0 .219 0 .326.005.034.002.066.007.1.009.237.014.473.045.705.09.047.01.092.024.138.034.082.02.165.037.246.06.037.01.073.025.11.037.087.027.174.053.259.085l.063.027c.217.084.428.184.63.3l-35.926-20.72Z",
    fill: "url(#emptyCerts_svg__l)",
    transform: "translate(0 29.596)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m284.626 183.698-17.014 9.817c.385 1.1.573 2.259.554 3.424v28.6c0 5.139 3.609 7.221 8.06 4.653l44.491-25.67-36.09-20.824Z",
    fill: "url(#emptyCerts_svg__m)",
    transform: "translate(0 29.596)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M250.329 207.23v14.644l18.64 10.754c-1.563-1.097-2.515-3.195-2.515-6.1v-28.601c0-5.138-3.61-7.22-8.063-4.652-4.452 2.57-8.062 8.817-8.062 13.955Z",
    fill: "url(#emptyCerts_svg__n)",
    fillRule: "nonzero",
    transform: "translate(0 29.596)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#emptyCerts_svg__o)",
    d: "m340.952 172.023-63.429 7.577 50.298 29.02 13.131-36.597z",
    transform: "translate(0 29.596)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#388A89",
    fillRule: "nonzero",
    d: "m327.82 240.191-7.103-4.098v-1.975l7.104 4.098zM340.952 203.594l-13.131 36.597v-1.975l13.131-36.597z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#DAE0F5",
    fillRule: "nonzero",
    d: "m298.964 250.708 23.542-13.584-1.789-1.031-23.541 13.583z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E8ECF7",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    d: "m322.506 207.528-1.789-3.006v1.975z",
    transform: "translate(0 29.596)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#emptyCerts_svg__p)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    d: "m340.952 173.998-13.131 36.597h3.422l13.131-36.597z",
    transform: "translate(0 29.596)"
  }), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#388A89",
    fillRule: "nonzero",
    d: "m176.352 319.388-36.09-20.824v-1.974l36.09 20.823z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#emptyCerts_svg__q)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    d: "m302.4 223.101-8.313 4.796 8.313 27.92-8.313 4.797h56.703l8.313-4.797-56.703-32.716z",
    transform: "translate(0 29.596)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(60.61 111.587)"
  }, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "emptyCerts_svg__s",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#emptyCerts_svg__r"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#emptyCerts_svg__s)",
    fillRule: "nonzero"
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#BBC0E6",
    d: "M233.478 178.623v-32.716l8.313-4.796v32.716l-8.313 4.796z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#CED3F8",
    d: "M0 43.912V11.196l233.478 134.71v32.717z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#F6F6FB",
    d: "M233.478 145.907 0 11.196l8.313-4.797L241.79 141.111l-8.313 4.796z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#emptyCerts_svg__t)",
    style: {
      mixBlendMode: "multiply"
    },
    d: "m148.389 123.13-15.354-41.575-10.086-5.82v32.716z",
    transform: "translate(0 6.4)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8ECF7",
    style: {
      mixBlendMode: "multiply"
    },
    d: "m133.035 81.555-12.517-7.222 8.25-4.833 18.692 10.785-14.425 1.27z",
    transform: "translate(0 6.4)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#emptyCerts_svg__u)",
    style: {
      mixBlendMode: "multiply"
    },
    d: "m212.311 160.011-15.353-41.575-10.087-5.82v32.717l25.44 14.678z",
    transform: "translate(0 6.4)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8ECF7",
    style: {
      mixBlendMode: "multiply"
    },
    d: "m196.958 118.436-12.517-7.222 8.25-4.832 18.691 10.784-14.424 1.27z",
    transform: "translate(0 6.4)"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#emptyCerts_svg__v)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    d: "m409.297 161.424-8.313 4.796 8.313 27.92-8.313 4.797h56.703L466 194.14z",
    transform: "translate(0 29.596)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(167.506 48.498)"
  }, _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "emptyCerts_svg__x",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#emptyCerts_svg__w"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#emptyCerts_svg__x)",
    fillRule: "nonzero"
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#BBC0E6",
    d: "M233.478 180.035v-32.716l8.313-4.797v32.716z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#CED3F8",
    d: "M0 45.324V12.607L233.478 147.32v32.716z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#F6F6FB",
    d: "M233.478 147.319 0 12.607l8.313-4.796L241.79 142.522z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#emptyCerts_svg__y)",
    style: {
      mixBlendMode: "multiply"
    },
    d: "m148.389 123.13-15.354-41.575-10.086-5.82v32.717l25.44 14.677z",
    transform: "translate(0 7.81)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8ECF7",
    style: {
      mixBlendMode: "multiply"
    },
    d: "m133.035 81.555-12.517-7.222 8.251-4.833 18.691 10.785-14.425 1.27z",
    transform: "translate(0 7.81)"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#emptyCerts_svg__z)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M61.096 138.708H38.017l8.494 5.052-8.494 4.902h23.079l8.623-4.976z",
    transform: "translate(0 29.596)"
  }), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#B9BEE4",
    fillRule: "nonzero",
    d: "m38.017 178.258 8.494-4.902v-23.1l-8.494 4.9v23.102z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#CCD1F6",
    fillRule: "nonzero",
    d: "m38.017 178.258-8.495-4.902v-23.1l8.495 4.9z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4F4F9",
    fillRule: "nonzero",
    d: "m38.017 155.156-8.495-4.9 8.495-4.9 8.494 4.9-8.494 4.9z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#emptyCerts_svg__A)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M369.602 201.353h-11.588l7.243 4.31-7.243 4.18h11.588l7.355-4.244z",
    transform: "translate(0 29.596)"
  }), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B7978",
    fillRule: "nonzero",
    d: "m358.014 239.44 7.243-4.182v-8.487l-7.243 4.178z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#57B5B4",
    fillRule: "nonzero",
    d: "m358.014 239.44-7.244-4.182v-8.487l7.244 4.178z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#74DDDC",
    fillRule: "nonzero",
    d: "m358.014 230.95-7.244-4.179 7.244-4.178 7.243 4.178z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M438.999 103.497c-2.343-1.352-5.459-1.975-8.518-1.884h-7.093v.786c-.883.272-1.734.64-2.537 1.098-4.362 2.535-4.337 6.643.052 9.178.788.445 1.621.806 2.486 1.075v.821h8.048c2.768-.046 5.509-.674 7.614-1.896 4.363-2.535 4.341-6.643-.052-9.178Z",
    fill: "url(#emptyCerts_svg__B)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    transform: "translate(0 29.596)"
  }), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M415.962 108.397c-2.208-1.276-3.314-2.95-3.309-4.62l.01-2.142c-.004 1.674 1.099 3.347 3.309 4.622 4.392 2.534 11.49 2.534 15.852.002 2.168-1.26 3.253-2.907 3.258-4.557l-.01 2.139c-.005 1.65-1.09 3.297-3.257 4.557-4.363 2.534-11.46 2.534-15.853 0Z",
    fill: "url(#emptyCerts_svg__C)",
    fillRule: "nonzero",
    transform: "translate(0 29.596)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M415.962 110.537c-2.208-1.276-3.314-2.95-3.309-4.62l.01-2.142c-.004 1.673 1.099 3.346 3.309 4.622 4.392 2.534 11.49 2.534 15.852.001 2.168-1.26 3.253-2.907 3.258-4.557l-.01 2.14c-.005 1.65-1.09 3.296-3.257 4.556-4.363 2.535-11.46 2.535-15.853 0Z",
    fill: "url(#emptyCerts_svg__D)",
    fillRule: "nonzero",
    transform: "translate(0 29.596)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M415.962 112.676c-2.208-1.275-3.314-2.95-3.309-4.62l.01-2.141c-.004 1.673 1.099 3.346 3.309 4.622 4.392 2.533 11.49 2.533 15.852.001 2.168-1.261 3.253-2.907 3.258-4.557l-.01 2.14c-.005 1.65-1.09 3.296-3.257 4.556-4.363 2.535-11.46 2.535-15.853 0Z",
    fill: "url(#emptyCerts_svg__C)",
    fillRule: "nonzero",
    transform: "translate(0 29.596)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M415.972 135.853c-4.391-2.533-4.416-6.643-.053-9.175 4.364-2.535 11.462-2.535 15.854 0 4.393 2.532 4.413 6.642.05 9.177-4.362 2.532-11.459 2.532-15.851-.002Z",
    fill: "#EFF2F6",
    fillRule: "nonzero"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#E9743E",
    fillRule: "nonzero",
    opacity: 0.393,
    d: "m430.143 130.426-8.976.457.278-2.016h-2.48l-.673 3.675 11.851-.684z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#emptyCerts_svg__E)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M233.763 102.454H217.69l16.273 9.68-16.273 9.391h26.03l11.549-6.663-21.506-12.408z",
    transform: "translate(0 29.596)"
  }), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#B9BEE4",
    fillRule: "nonzero",
    d: "m217.69 151.121 16.273-9.392v-29.166l-16.273 9.388z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#CCD1F6",
    fillRule: "nonzero",
    d: "m217.69 151.121-16.275-9.392v-29.166l16.275 9.388z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4F4F9",
    fillRule: "nonzero",
    d: "m217.69 121.951-16.275-9.388 16.275-9.386 16.273 9.386z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#emptyCerts_svg__F)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M31.343 297.784H10.768l10.768 6.405-10.768 6.215h20.575l10.931-6.308-10.931-6.312z",
    transform: "translate(0 29.596)"
  }), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#B9BEE4",
    fillRule: "nonzero",
    d: "m10.768 340 10.768-6.215v-24.09l-10.768 6.213z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#CCD1F6",
    fillRule: "nonzero",
    d: "M10.768 340 0 333.785v-24.09l10.768 6.213z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4F4F9",
    fillRule: "nonzero",
    d: "M10.768 315.908 0 309.696l10.768-6.21 10.768 6.21z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M230.86 10.632c-1.584-.914-3.69-1.335-5.759-1.273h-3.242v.53a8.55 8.55 0 0 0-1.715.743c-2.948 1.713-2.931 4.49.036 6.204a8.615 8.615 0 0 0 1.68.727v.554h3.888a10.821 10.821 0 0 0 5.147-1.28c2.948-1.715 2.933-4.492-.036-6.205Z",
    fill: "url(#emptyCerts_svg__G)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    transform: "translate(0 29.596)"
  }), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M216.84 16.839c-1.494-.863-2.24-1.994-2.237-3.124l.007-2.576c-.004 1.132.742 2.262 2.236 3.125 2.97 1.712 7.766 1.712 10.715 0 1.465-.851 2.2-1.964 2.203-3.08l-.008 2.575c-.002 1.115-.736 2.228-2.201 3.08-2.949 1.713-7.746 1.713-10.715 0Z",
    fill: "url(#emptyCerts_svg__H)",
    fillRule: "nonzero",
    transform: "translate(0 29.596)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M216.846 43.86c-2.968-1.712-2.984-4.49-.036-6.202 2.95-1.714 7.749-1.714 10.716 0 2.97 1.712 2.984 4.49.035 6.203-2.95 1.71-7.745 1.71-10.715-.001Z",
    fill: "#FFF",
    fillRule: "nonzero"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#E9743E",
    fillRule: "nonzero",
    opacity: 0.393,
    d: "m226.074 40.405-5.607.286.174-1.26h-1.55l-.42 2.296 7.403-.428z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M225.808 80.054c-1.43-.824-3.329-1.204-5.194-1.149h-2.925v.48a7.714 7.714 0 0 0-1.547.67c-2.66 1.545-2.645 4.05.032 5.595.48.272.988.492 1.515.656v.5h3.508a9.761 9.761 0 0 0 4.642-1.155c2.66-1.547 2.647-4.05-.031-5.597Z",
    fill: "url(#emptyCerts_svg__I)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    transform: "translate(0 29.596)"
  }), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M213.161 85.653c-1.347-.778-2.02-1.798-2.017-2.817l.005-2.324c-.002 1.02.67 2.04 2.018 2.819 2.679 1.544 7.005 1.544 9.665 0 1.323-.769 1.984-1.772 1.987-2.779l-.006 2.323c-.002 1.006-.664 2.01-1.986 2.779-2.66 1.545-6.987 1.545-9.665-.001Z",
    fill: "url(#emptyCerts_svg__J)",
    fillRule: "nonzero",
    transform: "translate(0 29.596)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M213.167 112.927c-2.677-1.545-2.692-4.051-.032-5.596s6.99-1.545 9.666 0c2.678 1.545 2.692 4.051.031 5.596-2.66 1.544-6.986 1.544-9.665 0Z",
    fill: "#FFF",
    fillRule: "nonzero"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#E9743E",
    fillRule: "nonzero",
    opacity: 0.393,
    d: "m221.49 109.81-5.057.258.157-1.137h-1.397l-.38 2.072 6.678-.386v-.806z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M210.39 261.657c-.366-.039-.732-.076-1.097-.11-7.21-.678-8.544-.782-13.79-1.217.37-.207.742-.414 1.115-.619 1.77-.977 2.1-1.893-1.064-1.826a7.15 7.15 0 0 0-.489.03c-.082.007-.164.018-.245.032-.073.013-.145.03-.216.051l-2.46.88-2.64.944a.934.934 0 0 0-.795.998c.02.116.078.222.163.303.065.059.14.104.223.133.048.017.097.03.147.038 2.161.347 3.416.27 4.128.117.132.008.274.016.423.023 5.088.96 6.28 1.515 12.503 2.868 1.404.329 2.774.784 4.095 1.361v-4.006Z",
    fill: "url(#emptyCerts_svg__K)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    transform: "translate(0 29.596)"
  }), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M170.761 263.337c-.195.904.415 1.19.34 1.693-.072.474-.408.406-.435.651.007.423-.244.809-.635.973-.917.512-1.723-.14-1.988-.546-.24-.371-.532-.444-.046-1.671.197-.498.678-.398.915-1.414.162.167 1.849.314 1.849.314Z",
    fill: "#FCD1A9",
    fillRule: "nonzero"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M173.66 222.841c-1.552 1.314-3.035 2.865-3.488 4.037-.736 1.38-1.562 6.256-1.574 6.763-.03 1.154 1.98 1.414 2.425.078.785-2.354 1.55-4.353 2.18-5.464.121-.074.696-.46 1.479-.99a4.34 4.34 0 0 0-1.021-4.424Z",
    fill: "url(#emptyCerts_svg__L)",
    transform: "translate(0 29.596)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M180.39 221.118c-.764-.922-1.55-1.877-3.02-.81-.808.327-2.288 1.331-3.71 2.533a4.34 4.34 0 0 1 1.022 4.424 922.48 922.48 0 0 0 5.927-4.053c.44-.44.546-1.172-.218-2.094Z",
    fill: "url(#emptyCerts_svg__M)",
    fillRule: "nonzero",
    transform: "translate(0 29.596)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M188.308 260.589c-1.156-2.4.402-2.874.402-2.874s.502-.271 2.342-1.382c1.693-1.022 3.28-1.212 3.165.614a.905.905 0 0 1-.197.548l-3.16 2.943c-.368.533-2.3.64-2.552.151Z",
    fill: "url(#emptyCerts_svg__N)",
    fillRule: "nonzero",
    transform: "translate(0 29.596)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M188.21 289.959c.033.075.06.147.099.226.25.488 2.183.383 2.551-.15l3.16-2.944a.904.904 0 0 0 .197-.548l-3.472 3.244c-.362.525-2.237.634-2.535.172Z",
    fill: "#20196F",
    fillRule: "nonzero"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M188.105 287.016c.669.007 1.337.057 2 .15.029.14.092.269.183.378l.048.046c.325.172.671.466.013.998a.996.996 0 0 1-1.293.063 1.186 1.186 0 0 0-.47-.418 1.061 1.061 0 0 0-.417-.12.14.14 0 0 0-.008-.035s-.236-1.04-.056-1.062Z",
    fill: "#FFF",
    fillRule: "nonzero"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M183.407 239.3c-1.652.243-8.023-2.705-9.675-2.462-.278 9.637 7.014 10.315 9.362 13.91 2.349 3.596 3.31 4.28 4.978 7.226.446.622 1.947.574 2.103-.21-.928-3.717-1.033-4.243-2.304-8.744-.81-2.865-2.346-5.79-4.464-9.72Z",
    fill: "url(#emptyCerts_svg__O)",
    transform: "translate(0 29.596)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M172.063 280.765a9.272 9.272 0 0 1-1.05-.124s-.176 3.659 1.456 2.947c.543-.237.327-2.823-.406-2.823Z",
    fill: "#FFF",
    fillRule: "nonzero"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M174.775 237.827c1.721.031 8.93 2.439 10.65 2.47-.23 6.48-.672 8.155-2.508 12.478-1.16 2.73-7.62 1.274-10.474 1.253.494-.564.23-2.338-.38-2.86 1.553.17 3.799-1.016 6.1-.732.092-2.09-.147-4.108-.861-5.653-1.096-2.372-2.837-4.1-2.527-6.956Z",
    fill: "url(#emptyCerts_svg__P)",
    transform: "translate(0 29.596)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M168.39 288.299c.909-.097 1.755-.434 2.146-1.534a7.203 7.203 0 0 1 1.367-2.465c.286-.33.145-1.413-.1-2.282-.116-.408.341-.898.1-1.176-.279-.324-1.367-.43-1.694-.48a12.823 12.823 0 0 1-.874 3.457l-.945 4.48Z",
    fill: "#2D2B50",
    fillRule: "nonzero"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M170.209 280.363c.91.292 1.055 2.657.4 4.02-.655 1.363-1.055 4.455-2.912 3.873-1.856-.582.473-3.855.583-4.51.109-.655-.219-4.074 1.929-3.383Z",
    fill: "#20196F",
    fillRule: "nonzero"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M177.013 240.753c3.577 2.006 7.321 2.011 8.598-.456-.478-4.593-.62-7.644.302-12.045-.272-2.431-.465-2.798-.153-4.214-.11-.476-1.573-1.491-2.64-2.464-1.152-1.05-1.93-2.05-2.523-2.172-4.893-.998-5.27 9.667-7.125 16.546-.227 2.965 1.779 3.817 3.541 4.805Z",
    fill: "url(#emptyCerts_svg__Q)",
    fillRule: "nonzero",
    transform: "translate(0 29.596)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M178.058 249.724c1.06-.766 1.122-2.422 1.13-3.478a5.158 5.158 0 0 1-.03-1.827c.367-2.295 2.148-4.042 3.92-3.631 3.57.827 2.622 2.621 2.254 4.914-.341 2.126-1.54 3.433-3.193 3.422a2.39 2.39 0 0 0 .572 1.663c-1.193.717-2.937.379-3.625.068-.734-.33-1.527-.616-1.028-1.13Z",
    fill: "#FCD1A9",
    fillRule: "nonzero"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M182.804 221.278a4.132 4.132 0 0 0-.258-.678c-.318.07-3.806.218-4.163-.767-.356.11-.449.212-.52.538-.138.627 2.143 2.01 4.94.907Z",
    fill: "url(#emptyCerts_svg__R)",
    fillRule: "nonzero",
    transform: "translate(0 29.596)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M180.479 209.699c.509-.262.967-.127 1.252-.308.674-.413 1.313-.676 1.67-.48.178.119.346.252.502.399.351.35 1.071-.396 1.244.51.044.232.064.468.06.704 1.686.217.856 1.752-.5 4.709 0-.61-1.02-1.59-1.02.543 0 .23.17.274.02.578-.151.303-1.12 1.068-1.76 1.707-.892.892-1.416.092-2.89.252a2.352 2.352 0 0 0-.39-1.344 3.928 3.928 0 0 1-.95-2.428c1.144.14-.891-2.961 2.762-4.842Z",
    fill: "url(#emptyCerts_svg__S)",
    fillRule: "nonzero",
    transform: "translate(0 29.596)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M192.991 257.057c.647-.647.294-1.212.626-1.589.313-.355.556-.12.71-.308.221-.355.636-.54 1.049-.468 1.036.065 1.356 1.039 1.358 1.518.001.437.205.654-.857 1.413-.431.309-.777-.033-1.518.684-.046-.225-1.368-1.25-1.368-1.25Z",
    fill: "#FCD1A9",
    fillRule: "nonzero"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M192.771 227.33c-2.13 1.275-2.939 1.819-3.756 2.331a67.464 67.464 0 0 1-1.25-2.056c-.552 1.788-1.933 2.452-3.321 2.693a31.358 31.358 0 0 0 2.994 2.833c1.088 1.123 6.783-3.788 7.123-4.164.774-.856-.581-2.362-1.79-1.638Z",
    fill: "url(#emptyCerts_svg__T)",
    transform: "translate(0 29.596)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M187.765 227.605c-.76-1.288-1.606-2.772-2.005-3.567-.282-.554-.947-.88-2.06-.436s-1.918 2.089-1.353 3.814c.171.631 1.04 1.746 2.097 2.882 1.388-.241 2.769-.905 3.32-2.693Z",
    fill: "url(#emptyCerts_svg__U)",
    fillRule: "nonzero",
    transform: "translate(0 29.596)"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.31 83.914a3.052 3.052 0 0 0-1.026-.907c-1.779-1.027-4.656-1.027-6.423 0-.908.526-1.343 1.222-1.315 1.913h-.001v2.572h4.731a6.442 6.442 0 0 0 3.029-.767 3.006 3.006 0 0 0 1.015-.908h23.525v-1.904H13.309Z",
    fill: "url(#emptyCerts_svg__V)",
    style: {
      mixBlendMode: "multiply"
    },
    transform: "translate(413.23)"
  }), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M1.34 86.724C.445 86.208-.003 85.529 0 84.853l.003-2.897c-.001.677.446 1.355 1.341 1.872 1.78 1.026 4.656 1.026 6.423 0 .878-.51 1.318-1.177 1.32-1.846l-.004 2.897c-.001.668-.442 1.335-1.32 1.846-1.767 1.027-4.644 1.027-6.423 0v-.001Z",
    fill: "url(#emptyCerts_svg__W)",
    transform: "translate(413.23)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M414.574 83.828c-1.779-1.027-1.788-2.691-.021-3.718 1.768-1.027 4.644-1.027 6.423 0 1.78 1.027 1.789 2.692.02 3.72-1.766 1.024-4.641 1.024-6.421-.002Z",
    fill: "#F6F6FB"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.545 82.798h4.31a1.667 1.667 0 0 0-.275-2.027H4.545v2.027Z",
    fill: "#DFE4F4",
    style: {
      mixBlendMode: "multiply"
    },
    transform: "translate(413.23)"
  }), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M3.529 82.554a.719.719 0 0 1-.425-.593L3.105 4.79a.72.72 0 0 0 .425.593c.639.325 1.395.325 2.035 0a.715.715 0 0 0 .418-.585l-.001 77.17a.715.715 0 0 1-.419.586 2.242 2.242 0 0 1-2.034 0Z",
    fill: "url(#emptyCerts_svg__X)",
    transform: "translate(413.23)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M1.03 3.51A3.511 3.511 0 0 1 4.545 0 3.511 3.511 0 1 1 1.03 3.51Z",
    fill: "url(#emptyCerts_svg__Y)",
    transform: "translate(413.23)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "m18.768 24.767.001-.004c.069-.283.224-.538.444-.73 3.408-3.407-8.346-8.223-13.988-10.337 0 0-.04 11.12 0 12.765 2.29-.189 10.923.403 12.592 2.875l.951-4.568Z",
    fill: "url(#emptyCerts_svg__Z)",
    transform: "translate(413.23)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M20.953 26.235c-1.435-.322-2.287-.804-2.185-1.467l-1.55 7.453c-.61 2.884 16.371-2.44 22.33-6.779-4.842 1.298-14.315 1.756-18.595.794Z",
    fill: "url(#emptyCerts_svg__aa)",
    transform: "translate(413.23)"
  })))));
};
export default SvgEmptyCerts;